import { motion } from 'framer-motion';
import styled from 'styled-components';

const HeaderContainerStyled = styled(motion.div)`
  display: flex;
  width: 100%;
  height: 88px;
  background: white;
  padding: 24px;
  justify-content: space-between;
  gap: 24px;
  position: fixed;
  top: 0;
  z-index: 1000;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 4px;
    background: linear-gradient(
      269.84deg,
      #c348ea 0.11%,
      #7212e8 45.3%,
      #4e018d 99.84%
    );
  }

  @media (min-width: 769px) {
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    position: relative;
  }
`;

const HeaderProfileContainerStyled = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 40px 1fr;
  max-width: 100%;
`;

const HeaderProfileIconContainerStyled = styled.div`
  min-width: 40px;
  height: 40px;
`;

const HeaderProfileInfoContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 4px;

  span {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: #494c66;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  strong {
    font-size: 18px;
    font-weight: 700;
    line-height: 20px;
    color: #0e141d;
  }
`;

const CloseMenuContainerStyled = styled.div`
  min-width: 32px;
  height: 32px;

  :hover {
    cursor: pointer;
  }
`;

export {
  HeaderContainerStyled,
  HeaderProfileContainerStyled,
  HeaderProfileIconContainerStyled,
  HeaderProfileInfoContainerStyled,
  CloseMenuContainerStyled,
};
